import { HttpClient } from '@angular/common/http'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { Subscription, switchMap } from 'rxjs'

import { environment } from '~env'

import { NotFoundComponent } from '../not-found/not-found.component'
import { CardComponent } from "~common/ui/card/card.component";
import { BadgeComponent } from "~common/ui/badge/badge.component";
import { TextComponent } from "~common/ui/text/text.component";

@Component({
  selector: 'sb-facebook-deletion',
  template: `
    <div class="main-content">
      @if (notFound === true) {
        <sb-not-found [showButton]="false"></sb-not-found>
      } @else {
        <div class="fb-deletion">
          <sb-card>
            <ng-template #content>
              <div class="flex justify-between items-center gap-4">
                <sb-text weight="600" noMargin>Facebook Data Deletion Status</sb-text>
                <div>
                  @if (deleted) {
                    <sb-badge variant="success">Deleted</sb-badge>
                  } @else {
                    <sb-badge variant="default">In progress</sb-badge>
                  }
                </div>
              </div>
            </ng-template>
          </sb-card>
        </div>
      }
    </div> 
  `,
  styles: [
    `
      .fb-deletion {
        padding: 3rem;
        margin: auto;
        max-width: 600px;
      }
    `,
  ],
  standalone: true,
  imports: [NotFoundComponent, CardComponent, BadgeComponent, TextComponent],
})
export class FacebookDeletionComponent implements OnInit, OnDestroy {
  title: string
  deleted = false
  notFound = false
  private routeSubscription = Subscription.EMPTY

  constructor(
    private route: ActivatedRoute,
    private httpClient: HttpClient,
  ) {}

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe()
  }

  ngOnInit() {
    this.routeSubscription = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.httpClient.get<{ deleted: boolean }>(this.endpoint(params.get('id'))))
    ).subscribe({
      next: (response) => (this.deleted = response.deleted),
      error: () => (this.notFound = true),
    })
  }

  private endpoint(id: string) {
    return `${environment.apiEndpoint}/v1.0/facebook-deletion/${id}`
  }
}
